import { useMutation } from "@tanstack/react-query";
import TagManager from "react-gtm-module";

import {
  ITrackLoanApplicationInput,
  ITrackLoanApplicationRateForecastExecutedResponse,
  trackLoanApplicationRateForecastExecuted,
} from "@/services/graphql/loan-application/trackLoanApplication";

export const useTrackLoanApplicationRateForecastExecuted = () => {
  return useMutation<
    ITrackLoanApplicationRateForecastExecutedResponse,
    undefined,
    ITrackLoanApplicationInput
  >({
    mutationFn: async ({ loanApplicationID }) => {
      return await trackLoanApplicationRateForecastExecuted({
        loanApplicationID,
      });
    },
    onSuccess: (data) => {
      const conversionData =
        data.trackLoanApplicationRateForecastExecuted.tracking;

      TagManager.dataLayer({
        dataLayer: {
          event: "LoanApplicationRateForecastExecuted",
          loanApplicationRateForecastExecutedConversion: conversionData,
        },
      });
    },
  });
};
